<template>
<div class="sideInfo">
  <template v-if="!edit">
    <EditBtn v-if="!edit" v-show="!btnHide" @click="$emit('edit')" :style="{
      position: 'absolute',
      top: '8px',
      right: '12px'
    }"></EditBtn>
    <slot/>
  </template>
  <template v-else>
    <slot name="edit"/>
    <Btns @save="$emit('save')" @cancel="$emit('cancel')"/>
  </template>
</div>
</template>

<script>
import EditBtn from '../../components/btn/edit.vue'
import Btns from '../btn/btns.vue'
export default {
  props: ['edit', 'btnHide'],
  components: {
    EditBtn,
    Btns
  }

}
</script>

<style lang="scss" scoped>
.sideInfo {
  position: relative;
  width: -webkit-fill-available;
  min-height: 200px;
  height: fit-content;
  border: 1px solid #989898;
  border-radius: 10px;
  padding: 25px 28px 24px;
}
</style>
